import React from 'react'
import {ReactComponent as Plus} from '../../../../images/main/plus.svg'
import {ReactComponent as Minus} from '../../../../images/main/minus.svg'
import styles from './styles.module.scss'

const QuestionVolginsky = () => {
  const [activeField, setActiveField] = React.useState(0)
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div>
          <p className={styles.title}>
            Жизнь в поселке
          </p>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.title}>Вопросы и ответы<br/>о жизни в поселке</p>
        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(1))}
              className={
                activeField === 2 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Какая инфраструктура в Вольгинском?
            </p>
            {activeField === 1 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(1)}/>
            )}
          </div>
          {activeField === 1 && (
            <p className={styles.answer}>
              В Вольгинском есть все условия для комфортной жизни: магазины шаговой доступности, универмаг, рынок и ТЦ. Для любителей спорта работают тренажерный зал и бассейн, а для гурманов — рестораны и магазины фермерских продуктов.<br/>
              Ценители природы оценят Владимирские леса и озера, добраться до которых можно пешком или на велосипеде.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(2))}
              className={
                activeField === 1 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Есть ли корпоративный транспорт?
            </p>
            {activeField === 2 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(2)}/>
            )}
          </div>
          {activeField === 2 && (
            <p className={styles.answer}>
              В компании работает корпоративный трансфер из г. Покров, п.&nbsp;Вольгинский, г. Петушки, который бесплатно доставит вас на работу и обратно.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(3))}
              className={
                activeField === 2 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Какие есть медицинские организации?
            </p>
            {activeField === 3 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(3)}/>
            )}
          </div>
          {activeField === 3 && (
            <p className={styles.answer}>
              В поселке и близлежащих городах работают коммерческие медицинские центры, в которых сотрудники могут получить услуги по ДМС, которое действует с момента трудоустройства в компанию.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(4))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Как быстро можно доехать от Вольгинского до Москвы и до Владимира?
            </p>
            {activeField === 4 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(4)}/>
            )}
          </div>
          {activeField === 4 && (
            <p className={styles.answer}>
              Добраться от Вольгинского до Москвы можно за два часа, а до Владимира путь еще короче — один час езды на автомобиле.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(5))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 6 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Компенсируете ли вы расходы на релокацию?
            </p>
            {activeField === 5 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(5)}/>
            )}
          </div>
          {activeField === 5 && (
            <p className={styles.answer}>
              К сожалению, расходы на переезд компания не покрывает, но мы предоставляем помощь с поиском комфортного жилья, регистрацией и оформлением детей в сад/школу. Помимо этого, ДМС для вас начинает действовать уже с первого дня оформления.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(6))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 7 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Предоставляет ли компания жилье?
            </p>
            {activeField === 6 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(6)}/>
            )}
          </div>
          {activeField === 6 && (
            <p className={styles.answer}>
              Мы предоставляем комфортные квартиры в аренду в Покрове или Вольгинском. Вы оплачиваете только коммунальные услуги. Добраться на работу можно корпоративным трансфером.<br />
              Тем, кому важна активная городская жизнь и инфраструктура, мы арендуем жилье в г. Орехово-Зуево. Отсюда путь до Generium составит 30-40 минут на машине.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(7))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 8 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Есть ли на территории детский сад, школа?
            </p>
            {activeField === 7 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(7)}/>
            )}
          </div>
          {activeField === 7 && (
            <p className={styles.answer}>
              Да, в Вольгинском есть детский сад и множество программ дополнительного образования: спортивные секции, творческие кружки и курсы иностранных языков.<br />
              Школа в поселке — с углубленным изучением химии и биологии. После выпуска компания помогает абитуриентам поступить в профильные вузы.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(8))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 9
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Может ли супруг/супруга трудоустроиться в Generium?
            </p>
            {activeField === 8 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(8)}/>
            )}
          </div>
          {activeField === 8 && (
            <p className={styles.answer}>
              По возможности мы оказываем содействие в трудоустройстве супругов.
            </p>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(9))}
              className={
                activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6 || activeField === 7 || activeField === 8
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Могу ли я переехать с домашними животными?
            </p>
            {activeField === 9 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(9)}/>
            )}
          </div>
          {activeField === 9 && (
            <p className={styles.answer}>
              Да, мы стараемся подобрать квартиры с учетом домашних питомцев, хотя стоит понимать, что это сокращает количество вариантов жилья.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default QuestionVolginsky
